import { FC, useState } from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import EventBox from '../Event'
import { IEvent } from '../../../../types/event.type'

import styles from './styles.module.scss'
import { formatDate } from '../../../../utils/dateFormatter'

interface IProps {
  created_at: Date
  runNumber: string
  events: IEvent[]
  open: boolean
}

const EventsGroup: FC<IProps> = ({ events, runNumber, open, created_at }) => {
  const theme = useTheme()

  const [isOpen, setIsOpen] = useState(open)

  return (
    <Box
      className={styles.group}
      id="eventsGroup"
      data-testid="eventGroup"
      sx={{
        background: isOpen ? theme.palette.elevated.main : null,
        ':hover': {
          background: theme.palette.elevated.main,
        },
        borderBottom: '1px solid ' + theme.palette.elevated.light,
        ':last-child': {
          borderBottom: 'none',
        },
      }}
    >
      <Box
        className={styles.header}
        onClick={() => setIsOpen(!isOpen)}
        data-testid="eventGroupTitle"
      >
        <ArrowBackIosNewOutlinedIcon
          data-testid="arrowIcon"
          className={isOpen ? styles.arrow : styles.bottomArrow}
        />
        <Typography className={styles.title}>
          Playbook run #{runNumber}
        </Typography>
        <Typography className={styles.created}>
          {formatDate(created_at)}
        </Typography>
      </Box>
      {isOpen && (
        <Box className={styles.events} id="events" style={{ width: '100%' }}>
          {events.map((event, ind) => (
            <EventBox key={event.text + ind} {...event} />
          ))}
        </Box>
      )}
    </Box>
  )
}

export default EventsGroup
